// extracted by mini-css-extract-plugin
export var externalLink = "_8s-0";
export var internalLinkLabel = "_8s-1";